/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { CommentContainer_comment$ref } from "./CommentContainer_comment.graphql";
import { IgnoredTombstoneOrHideContainer_comment$ref } from "./IgnoredTombstoneOrHideContainer_comment.graphql";
import { ReplyListContainer1_comment$ref } from "./ReplyListContainer1_comment.graphql";
declare const _UnansweredCommentsTabContainer_comment$ref: unique symbol;
export type UnansweredCommentsTabContainer_comment$ref = typeof _UnansweredCommentsTabContainer_comment$ref;
export type UnansweredCommentsTabContainer_comment = {
    readonly id: string;
    readonly " $fragmentRefs": CommentContainer_comment$ref & ReplyListContainer1_comment$ref & IgnoredTombstoneOrHideContainer_comment$ref;
    readonly " $refType": UnansweredCommentsTabContainer_comment$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "UnansweredCommentsTabContainer_comment",
    "type": "Comment",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "FragmentSpread",
            "name": "CommentContainer_comment",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "ReplyListContainer1_comment",
            "args": null
        },
        {
            "kind": "FragmentSpread",
            "name": "IgnoredTombstoneOrHideContainer_comment",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'bf619e399e4b4e321744bcad3afa917d';
export default node;
